export default __webpack_public_path__ + "static/media/bannerA.522d62a5.png";